import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../shared/services//http/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LoggedGuard implements CanActivate {
  constructor(private authService: AuthService,private router:Router){

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.authService.getToken()) {
        let userDetails = this.authService.getDataFromLocalStorage('user_details');
        userDetails = JSON.parse(userDetails);

        if (userDetails?.type == 'student') {
          this.router.navigate(['/student/dashboard']);
        } else if (userDetails?.type == 'parent') {
          this.router.navigate(['/student/dashboard']);
        }
        // if (userDetails?.type == 'teacher') {
        //   this.router.navigate(['/teacher/dashboard']);
        // }
        // else if (userDetails?.type == 'institute') {
        //   this.router.navigate(['/institute/dashboard']);
        // }
        else{
          this.router.navigate(['/auth/login']);
        }
        return false;
      } else {
        return true;
      }
  }
  
}


